interface IProps {
  children?: React.ReactNode;
  extraClasses?: string;
}
const Header: React.FC<IProps> = ({ children, extraClasses }) => {
  return (
    <div
      className={`text-xl font-bold text-navy-700 dark:text-white ${extraClasses}`}
    >
      {children}
    </div>
  );
};
export default Header;
